<template>
    <div class="">
        <div class="goods-title">{{ title }}</div>
        <ul class="goods-list">
            <GoodsItem
                v-for="item in goodsList"
                :key="item.id"
                :cover="item.cover"
                :price="item.showPrice"
                @click.native="showGoodsDetail(item)"
            />
        </ul>

        <MallDialog :visible.sync="goodsDetailVisible" title="商品详情" confirmBtnText="兑换" :confirm="buyGoods">
            <GoodsDetailDialogContent :detail="currentGoods" />
        </MallDialog>
    </div>
</template>

<script>
import { apiBuyProduct } from "@/models/mall"
import MallDialog from "@/components/mall-dialog/index.vue"
import GoodsItem from "./GoodsItem.vue"
import GoodsDetailDialogContent from "./GoodsDetailDialogContent.vue"

export default {
    name: 'GoodsList',
    components: {
        GoodsItem,
        GoodsDetailDialogContent,
        MallDialog,
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        goodsList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            goodsDetailVisible: false,
            currentGoods: {},
        }
    },
    methods: {
        showGoodsDetail(item) {
            this.currentGoods = item
            this.goodsDetailVisible = true
        },
        async buyGoods() {
            try {
                if (!this.currentGoods.id) {
                    throw new Error('商品不存在')
                }
                this.$lLoading.show()
                await apiBuyProduct({
                    productId: this.currentGoods.id,
                    num: 1,
                })
                this.$lPrompt({
                    message: '购买成功',
                })
            } catch (error) {
                console.error(error)
                this.$lPrompt({
                    message: error.msg,
                })
            } finally {
                this.$lLoading.hide()
            }
        },
    }
}
</script>

<style scoped>
.goods-title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 62px;
    margin: 16px 0;
    background: #eac66e;
    border-radius: 28px;
    box-shadow: 0px 0px 7px 3px rgba(205,87,51,0.20) inset;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
}
.goods-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;
    list-style: none;
}
</style>